import { render, staticRenderFns } from "./ObjectiveDescription.vue?vue&type=template&id=095239cb&scoped=true"
import script from "./ObjectiveDescription.vue?vue&type=script&lang=js"
export * from "./ObjectiveDescription.vue?vue&type=script&lang=js"
import style0 from "./ObjectiveDescription.vue?vue&type=style&index=0&id=095239cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095239cb",
  null
  
)

export default component.exports